export const GAMESETTING = {
  easy: { min: 1, max: 10 },
  medium: { min: 1, max: 100 },
  hard: { min: 1, max: 1000 },
};
